import type { RootState } from '/business/shared/state/store';

export default (state: RootState) => state.basket?.lastRetrievedAt;
